import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";
import { media } from "../Utils/media";
import serviceTopBg from "../Assets/Images/serviceTopBg.jpg";
import serviceSec3Bg from "../Assets/Images/serviceSec3Bg.png";
import service3List1 from "../Assets/Images/service3List1.jpg";
import service3List2 from "../Assets/Images/service3List2.jpg";
import service3List3 from "../Assets/Images/service3List3.jpg";
import service3List1M from "../Assets/Images/service3List1M.jpg";
import service3List2M from "../Assets/Images/service3List2M.jpg";
import service3List3M from "../Assets/Images/service3List3M.jpg";
import { fluidFont } from "../Utils/fontSize";

const Service3 = () => {
  useEffect(() => {
    AOS.init({});
  }, []);
  const [isHoverd1, setIsHoverd1] = useState(false);
  const [isHoverd2, setIsHoverd2] = useState(false);
  const [isHoverd3, setIsHoverd3] = useState(false);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  return (
    <PageContainer>
      <PageWrapper>
        <SectionTop>
          <SectionTopTitleArea>
            <SectionTopTitleContainer>
              <SectionTopTitleCopy data-aos="fade-right" data-aos-delay="200" data-aos-duration="1400">
                Global Customer Acquisition
                <br />
                <StrokeText>& Growth Strategies</StrokeText>
              </SectionTopTitleCopy>
            </SectionTopTitleContainer>
          </SectionTopTitleArea>
          <SectionTopBG />
        </SectionTop>
        <Section1Container>
          <Wrapper>
            <Section1TopArea>
              <Section1TopTitleArea>
                <Section1TopTitleCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                  Global Customer Acquisition & Growth Strategies
                </Section1TopTitleCopy>
                <Section1TopMainCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                  글로벌 고객 전환 마케팅
                </Section1TopMainCopy>
              </Section1TopTitleArea>
              <Section1TopImageContainer>
                <img src={require("../Assets/Images/service3Bg.png")} alt="service3Bg" />
              </Section1TopImageContainer>
            </Section1TopArea>
            <Section1BottomArea data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
              <Section1BottomLine />
              <Section1BottomCopy>
                예약 · 상담이 중요한 고관여 업종을 위한
                <br />
                <span style={{ fontWeight: "700" }}>실전형 글로벌 마케팅 전략</span>
                입니다.
              </Section1BottomCopy>
            </Section1BottomArea>
          </Wrapper>
        </Section1Container>
        <Section2Container>
          <Wrapper>
            <Section2Title data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
              <Section2TitleCopy>Summary</Section2TitleCopy>
            </Section2Title>
            <Section2ItemArea>
              <Section2ItemContainer
                onMouseLeave={() => setIsHoverd1(false)}
                onMouseEnter={() => setIsHoverd1(true)}
                data-aos="fade-up"
                data-aos-delay="250"
                data-aos-duration="1400"
              >
                <Section2ItemImageWrapper>
                  <img src={require("../Assets/Images/serviceItem1.jpg")} alt="serviceItem1" />
                </Section2ItemImageWrapper>
                <Section2ItemTextWrapper>
                  <Section2ItemTitleCopy>스레드 올인원</Section2ItemTitleCopy>
                  <Section2ItemBodyCopy1 $isHoverd1={isHoverd1} $isMobile={isMobile}>
                    채널 초기 구축부터 콘텐츠 운영, 확산,
                    <br />
                    그리고 최종 구매 전환까지!
                    <br />
                    스레드 마케팅의 모든 것을 책임지고
                    <br />
                    성과로 보여드립니다.
                  </Section2ItemBodyCopy1>
                </Section2ItemTextWrapper>
              </Section2ItemContainer>
              <Section2ItemContainer
                onMouseLeave={() => setIsHoverd2(false)}
                onMouseEnter={() => setIsHoverd2(true)}
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1400"
              >
                <Section2ItemImageWrapper>
                  <img src={require("../Assets/Images/serviceItem2.jpg")} alt="serviceItem2" />
                </Section2ItemImageWrapper>
                <Section2ItemTextWrapper>
                  <Section2ItemTitleCopy>콘텐츠 시너지 창출</Section2ItemTitleCopy>
                  <Section2ItemBodyCopy2 $isHoverd2={isHoverd2} $isMobile={isMobile}>
                    잘 만든 스레드 콘텐츠 하나로
                    <br />
                    X(구 트위터), 링크드인까지!
                    <br />
                    핵심 메시지의 파급력을 여러 플랫폼으로
                    <br />
                    확장하여 브랜드 영향력을 극대화합니다.
                  </Section2ItemBodyCopy2>
                </Section2ItemTextWrapper>
              </Section2ItemContainer>
              <Section2ItemContainer
                onMouseLeave={() => setIsHoverd3(false)}
                onMouseEnter={() => setIsHoverd3(true)}
                data-aos="fade-up"
                data-aos-delay="350"
                data-aos-duration="1400"
              >
                <Section2ItemImageWrapper>
                  <img src={require("../Assets/Images/serviceItem3.jpg")} alt="serviceItem3" />
                </Section2ItemImageWrapper>
                <Section2ItemTextWrapper>
                  <Section2ItemTitleCopy>글로벌 성공 지원</Section2ItemTitleCopy>
                  <Section2ItemBodyCopy3 $isHoverd3={isHoverd3} $isMobile={isMobile}>
                    미국, 일본 등 해외 시장,
                    <br />
                    이제 현지 맞춤형 채널 운영과
                    <br />
                    검증된 인플루언서 협업으로
                    <br />
                    성공적인 브랜드 안착을 실현하세요.
                  </Section2ItemBodyCopy3>
                </Section2ItemTextWrapper>
              </Section2ItemContainer>
            </Section2ItemArea>
          </Wrapper>
        </Section2Container>
        <Section3BG>
          <Section3Container>
            <Wrapper>
              <Section3TitleCopy data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
                Key <StrokeText>Services</StrokeText>
              </Section3TitleCopy>
              <Section3List>
                <Section3Item1 data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <Section3ItemText>
                    <Section3ItemTitleCopy>다국어 운영 노하우</Section3ItemTitleCopy>
                    <Section3ItemBodyCopy>
                      글로벌 타깃 맞춤형
                      <br />
                      다국어 콘텐츠 운영
                    </Section3ItemBodyCopy>
                    <Section3ItemSubCopy>국가별 맞춤 번역, 현지화 편집까지 전 과정을 지원합니다.</Section3ItemSubCopy>
                  </Section3ItemText>
                </Section3Item1>
                <Section3Item2 data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <Section3ItemText>
                    <Section3ItemTitleCopy>퍼널 최적화 설계</Section3ItemTitleCopy>
                    <Section3ItemBodyCopy>
                      상담 · 예약
                      <br />
                      유도형 퍼널 설계
                    </Section3ItemBodyCopy>
                    <Section3ItemSubCopy>문의부터 예약까지 이어지도록, 콘텐츠 내 전환 흐름을 전략적으로 구성합니다.</Section3ItemSubCopy>
                  </Section3ItemText>
                </Section3Item2>
                <Section3Item3 data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
                  <Section3ItemText>
                    <Section3ItemTitleCopy>다양한 업종 가능</Section3ItemTitleCopy>
                    <Section3ItemBodyCopy>
                      의료·뷰티·헬스케어까지
                      <br />
                      전방위 마케팅 적용
                    </Section3ItemBodyCopy>
                    <Section3ItemSubCopy>상담과 예약 전환이 중요한 고관여 업종에 특화된 전략을 제안합니다.</Section3ItemSubCopy>
                  </Section3ItemText>
                </Section3Item3>
              </Section3List>
            </Wrapper>
          </Section3Container>
        </Section3BG>
      </PageWrapper>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: block;
  background-color: #000000;
  overflow-x: hidden;
`;

const PageWrapper = styled.div`
  display: block;
  box-sizing: border-box;
`;

const SectionTop = styled.div`
  display: block;
  position: relative;
  box-sizing: border-box;
  ${media.web`
      margin-top: 240px;
  `}
  ${media.mobile`
      margin-top: 136px;
  `}
`;

const SectionTopTitleArea = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(-24%);
`;

const SectionTopTitleContainer = styled.div`
  width: 100%;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
  box-sizing: border-box;
`;

const SectionTopTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  line-height: 110%;
  ${media.web`
      font-size: ${fluidFont(72, 100)};
  `}
  ${media.mobile`
      font-size: 40px;
  `}
`;

const SectionTopBG = styled.div`
  background-attachment: fixed;
  width: 100%;
  box-sizing: border-box;
  background: url(${serviceTopBg}) no-repeat center / cover;
  ${media.web`
    height:500px;
  `};
  ${media.mobile`
    background-size: 200%;
    background-position: top 11% center;
    height:320px;
  `};
`;

const StrokeText = styled.span`
  -webkit-text-stroke: 1px #ffffff;
  color: transparent !important;
`;

const Section1Container = styled.div`
  display: block;
  overflow: hidden;
  box-sizing: border-box;
  ${media.web`
    padding: 160px 0 180px;
  `}
  ${media.mobile`
    padding: 40px 0 180px;
  `}
`;

const Wrapper = styled.div`
  display: block;
  box-sizing: border-box;
  width: 100%;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
`;

const Section1TopArea = styled.div`
  position: relative;
`;

const Section1TopTitleArea = styled.div`
  width: 100%;
  margin: 0;
  position: absolute;
  z-index: 1;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Section1TopTitleCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 12px;
  ${media.web`
      font-size: ${fluidFont(16, 24)};
  `}
  ${media.mobile`
      font-size: 16px;
  `}
`;

const Section1TopMainCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  line-height: 1.35;
  ${media.web`
      font-size:${fluidFont(32, 64)};
  `}
  ${media.mobile`
      font-size: 32px;
  `}
`;

const Section1TopImageContainer = styled.div`
  max-width: 640px;
  margin: 0 auto;

  &:hover img {
    transform: scale(1.05);
  }

  img {
    transition: transform 1s ease-in-out;
    display: block;
    width: 100%;
    height: auto;
  }
`;

const Section1BottomArea = styled.div`
  display: block;
`;

const Section1BottomLine = styled.div`
  display: block;
  background: #ffffff;
  width: 1px;
  ${media.web`
      margin: 60px auto;
      height: 300px;
  `}
  ${media.mobile`
      margin: 40px auto;
      height: 150px;
  `}
`;

const Section1BottomCopy = styled.div`
  text-align: center;
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  line-height: 1.6;
  ${media.web`
      font-size: ${fluidFont(20, 36)};
  `}
  ${media.mobile`
      font-size: 16px;
  `}
`;

const Section2Container = styled.div`
  display: block;
  overflow: hidden;
  box-sizing: border-box;
  padding-bottom: 200px;
`;

const Section2Title = styled.div`
  text-align: left;
  ${media.web`
 margin-bottom: 80px;
`}
  ${media.mobile`
 margin-bottom: 40px;
`}
`;

const Section2TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  line-height: 1.35;
  ${media.web`
      font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
  text-align:center;
      font-size: 32px;
  `}
`;

const Section2ItemArea = styled.div`
  display: flex;
  gap: 20px;
  ${media.mobile`
    flex-direction:column;
  `}
`;

const Section2ItemContainer = styled.div`
  overflow: hidden;
  position: relative;
  &:hover img {
    transform: scale(1.05);
  }

  img {
    transition: transform 1s ease-in-out;
    display: block;
    width: 100%;
    height: auto;
  }
  border-radius: 20px;
`;

const Section2ItemImageWrapper = styled.div`
  display: block;
  box-sizing: border-box;
  ${media.mobile`
    height: 400px;
  `}
`;

const Section2ItemTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
`;

const Section2ItemTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  ${media.web`
      font-size: ${fluidFont(14, 32)};
  `}
  ${media.mobile`
      font-size: 24px;
  `}
`;

const Section2ItemBodyCopy1 = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  position: relative; // ::before 절대 위치를 위해 필요
  transition: all 0.6s;
  font-weight: 700;
  line-height: 1.6;
  ${media.web`
    font-size: ${fluidFont(12, 20)};
  `}
  ${media.mobile`
    font-size: 16px;
  `}

  ${({ $isHoverd1, $isMobile }) =>
    $isHoverd1 || $isMobile
      ? `
        margin-top: 80px;
        height: 130px;
        overflow: visible;
      `
      : `
        margin-top: 0px;
        height: 0;
        overflow: hidden;
      `}

  &::before {
    content: "";
    display: block;
    width: 50px;
    height: 1px;
    background-color: #ffffff;
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Section2ItemBodyCopy2 = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  position: relative; // ::before 절대 위치를 위해 필요
  transition: all 0.6s;
  font-weight: 700;
  line-height: 1.6;
  ${media.web`
    font-size: ${fluidFont(12, 20)};
  `}
  ${media.mobile`
    font-size: 16px;
  `}

  ${({ $isHoverd2, $isMobile }) =>
    $isHoverd2 || $isMobile
      ? `
        margin-top: 80px;
        height: 130px;
        overflow: visible;
      `
      : `
        margin-top: 0px;
        height: 0;
        overflow: hidden;
      `}

  &::before {
    content: "";
    display: block;
    width: 50px;
    height: 1px;
    background-color: #ffffff;
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Section2ItemBodyCopy3 = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  position: relative; // ::before 절대 위치를 위해 필요
  transition: all 0.6s;
  font-weight: 700;
  line-height: 1.6;
  ${media.web`
    font-size: ${fluidFont(12, 20)};
  `}
  ${media.mobile`
    font-size: 16px;
  `}

  ${({ $isHoverd3, $isMobile }) =>
    $isHoverd3 || $isMobile
      ? `
        margin-top: 80px;
        height: 130px;
        overflow: visible;
      `
      : `
        margin-top: 0px;
        height: 0;
        overflow: hidden;
      `}

  &::before {
    content: "";
    display: block;
    width: 50px;
    height: 1px;
    background-color: #ffffff;
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Section3BG = styled.div`
  margin: 0px auto;
  box-sizing: border-box;
  width: 100%;
`;

const Section3Container = styled.div`
  background: url(${serviceSec3Bg}) no-repeat center / cover;
  overflow: hidden;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  inset: 0px auto auto 0px;
  margin: 0px;
  left: 0px;
  ${media.web`
    padding: 200px 0px;
  `}
  ${media.mobile`
    padding: 80px 0px;
  `}
`;

const Section3TitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  margin-bottom: 80px;
  ${media.web`
  font-size: ${fluidFont(32, 64)};
  `}
  ${media.mobile`
  text-align:center;
  font-size: 32px;
  `};
`;

const Section3List = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1430px;
`;

const Section3Item1 = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  transition: transform 0.3s ease;
  will-change: transform;
  height: 440px;
  border-radius: 15px;
  margin-bottom: 24px;
  ${media.web`
    background: url(${service3List1}) no-repeat center / cover;
    align-items: center;
    padding: 0 90px;
  `}
  ${media.mobile`
    background: url(${service3List1M}) no-repeat center / cover;
    align-items: flex-end;
    padding: 34px 30px;
  `}
`;

const Section3Item2 = styled.div`
  display: flex;
  box-sizing: border-box;
  height: 440px;
  border-radius: 15px;
  margin-bottom: 24px;
  transition: transform 0.3s ease;
  will-change: transform;
  width: 100%;
  ${media.web`
    background: url(${service3List2}) no-repeat center / cover;
    align-items: center;
    padding: 0 90px;
  `}
  ${media.mobile`
    background: url(${service3List2M}) no-repeat center / cover;
    align-items: flex-end;
    padding: 34px 30px;
  `}
`;

const Section3Item3 = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  transition: transform 0.3s ease;
  will-change: transform;
  height: 440px;
  border-radius: 15px;
  margin-bottom: 24px;
  ${media.web`
    background: url(${service3List3}) no-repeat center / cover;
    align-items: center;
    padding: 0 90px;
  `}
  ${media.mobile`
    background: url(${service3List3M}) no-repeat center / cover;
    align-items: flex-end;
    padding: 34px 30px;
  `}
`;

const Section3ItemText = styled.div`
  ${media.web`
    width: 50%;
  `}
  ${media.mobile`
    width: 80%;
  `}
`;

const Section3ItemTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 600;
  line-height: 1.4;
  ${media.web`
    font-size: ${fluidFont(14, 18)};
  `}
  ${media.mobile`
    font-size: 14px;
  `};
`;

const Section3ItemBodyCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  margin: 10px 0 20px;
  line-height: 1.4;
  ${media.web`
    font-weight: 700;
    font-size: ${fluidFont(20, 50)};
  `}
  ${media.mobile`
    font-weight: 800;
font-size: 24px;
`}
`;

const Section3ItemSubCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  ${media.web`
    font-size: ${fluidFont(14, 18)};
  `}
  ${media.mobile`
    font-size: 14px;
  `}
`;

export default Service3;
